module.exports = __webpack_public_path__ + "static/media/599.756(7).45fc0239.pdf";